export default {
  forbidden_title: '403 - Forbidden',
  forbidden_message:
    'You do not have the correct permissions to view this page.'
};
